import moment from 'moment';

const getDates = (startDate, stopDate) => {
    const dateArray = [];
    let currentDate = new Date(startDate);
    while (currentDate.getTime() <= new Date(stopDate).getTime()) {
        dateArray.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateArray;
};

export const getBlockedDayEvents = unavailables => {
    const events = [];
    unavailables = unavailables?.filter(u => u.Active) || [];

    unavailables.forEach(({ StartDateTime, EndDateTime }) => {
        const endStr = EndDateTime.format('MM/DD/YYYY hh:mm A');

        if (StartDateTime.format('LL') === EndDateTime.format('LL')) {
            const isFullDay =
                StartDateTime.hour() === 0 &&
                StartDateTime.minute() === 0 &&
                EndDateTime.hour() === 23 &&
                EndDateTime.minute() === 59;

            events.push({
                title: 'Blocked',
                start: StartDateTime.toDate(),
                end: EndDateTime.toDate(),
                allDay: isFullDay,
                classNames: 'tw-block',
                textColor: '#ffffff',
                backgroundColor: '#D5DCE1',
                borderColor: '#B0BEC5',
                extendedProps: {
                    type: 'blocked'
                }
            });
        } else {
            const dates = getDates(StartDateTime, EndDateTime.clone().set({ h: 23, m: 59 }));
            dates.forEach((d, i) => {
                let eventStart = moment(d).startOf('day');
                let eventEnd = moment(d).set({ h: 23, m: 59 });
                let isFullDay = true;

                if (i === 0) {
                    eventStart = StartDateTime;
                    if (!(StartDateTime.hour() === 0 && StartDateTime.minute() === 0)) {
                        isFullDay = false;
                    }
                }

                if (i === dates.length - 1) {
                    eventEnd = EndDateTime;
                    if (!(EndDateTime.hour() === 23 && EndDateTime.minute() === 59 && endStr.includes('PM'))) {
                        isFullDay = false;
                    }
                }

                events.push({
                    title: 'Blocked',
                    start: eventStart.toDate(),
                    end: eventEnd.toDate(),
                    allDay: isFullDay,
                    classNames: 'tw-block',
                    textColor: '#ffffff',
                    backgroundColor: '#D5DCE1',
                    borderColor: '#B0BEC5',
                    extendedProps: {
                        type: 'blocked'
                    }
                });
            });
        }
    });

    return events;
};
